import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { VideoWithStaticImagesContent } from './VideoWithStaticImagesContent';
import { VideoWrapper } from './VideoWithStaticImages.styles';

export interface VideoWithStaticImagesMobileProps {
  readonly title: string;
  readonly video: string;
  readonly videoPoster: string;
}

export const VideoWithStaticImagesMobile: React.FC<VideoWithStaticImagesMobileProps> = props => {
  return (
    <VideoWrapper>
      <CloudImage src={props.videoPoster} width="100%" />
      <VideoWithStaticImagesContent {...props} />
    </VideoWrapper>
  );
};
